import { render, staticRenderFns } from "./CountryFlag.vue?vue&type=template&id=d98c2624"
import script from "./CountryFlag.vue?vue&type=script&lang=js"
export * from "./CountryFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d98c2624')) {
      api.createRecord('d98c2624', component.options)
    } else {
      api.reload('d98c2624', component.options)
    }
    module.hot.accept("./CountryFlag.vue?vue&type=template&id=d98c2624", function () {
      api.rerender('d98c2624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CountryFlag.vue"
export default component.exports